import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';

import { DisplayComponent } from 'formlabs-web-components/BaseComponents';

import './Amount.module.css';

const Amount = ({
  defaultValue = 1,
  disabled = false,
  min = 1,
  onAmountChange = null,
  value = null // use to override internal state; set to null for reset
}) => {
  const { t } = useTranslation();
  const [amount, setAmount] = useState(defaultValue);

  useEffect(
    () => {
      if (onAmountChange) {
        onAmountChange(amount);
      }
    },
    [amount]
  );

  useEffect(
    () => {
      if (value !== null) {
        setAmount(value);
      }
    },
    [value]
  );

  const changeAmount = step => {
    const value = amount + step;
    if (value < min) {
      return;
    }

    setAmount(value);
  };

  const handleAdd = () => {
    changeAmount(1);
  };

  const handleSubstract = () => {
    changeAmount(-1);
  };

  const handleChange = event => {
    const value = parseInt(event.target.value, 10);
    if (!value || value < min) {
      return;
    }
    setAmount(value);
  };

  const handleFocus = event => {
    event.target.select();
  };

  return (
    <div styleName={classnames('container', { disabled })}>
      <button styleName="button" disabled={disabled} onClick={handleSubstract}>
        -
      </button>
      <input
        styleName="input"
        type="number"
        disabled={disabled}
        value={amount}
        onChange={handleChange}
        onFocus={handleFocus}
        min={min}
        aria-label={t('Set quantity')}
      />
      <button styleName="button" disabled={disabled} onClick={handleAdd}>
        +
      </button>
    </div>
  );
};

export default DisplayComponent(Amount);
